import * as utils from "@twiage/utils";

import type { AbortAll } from "./types/AbortAll";
import type { HTTPError401Handler } from "./types/HTTPError401Handler";

const httpError401HandlerLog = utils.log("HTTP_ERROR_401_HANDLER");

export const makeHTTPError401Handler =
  ({ abortAll }: { abortAll: AbortAll }): HTTPError401Handler =>
  () => {
    abortAll({ reason: "logout" });

    httpError401HandlerLog.warn("401 Unauthorized");

    utils.mainEventBus.emit("logout");
  };
